import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export const round = 4;


const firebaseConfig = {
    apiKey: "AIzaSyCJQ0R62rDayuMf4fsd729okxICyjJd4MY",
    authDomain: "asta-tournaments.firebaseapp.com",
    projectId: "asta-tournaments",
    storageBucket: "asta-tournaments.appspot.com",
    messagingSenderId: "463076099444",
    appId: "1:463076099444:web:3eee4a8550a5c78d841821",
    measurementId: "G-Y68MGJL95X"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.firestore();
